import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import preview from '../assets/icons/preview.svg';
import video from '../assets/icons/video.svg';
import check from '../assets/icons/check.svg';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Align } from "../interfaces/Esercizio";
import alert from '../assets/icons/alert.svg';
import { FixedSizeList, ListChildComponentProps } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import memoize from 'lodash/memoize';
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: Align;
  format?: (value: number) => string;
  width: string;
}

interface Row {
  [key: string]: any;
}

interface Props {
  columns: Column[];
  rows: Row[];
  navTable: string;
  onRowClick?: (row: Row, positionOn?: number) => void;
  selectedRowId?: number;
  draggableRows?: boolean;
  onDragStart?: (row: Row, event: React.DragEvent) => void;
  stickyColumnIds?: string[];
  heightTable?: string;
  edit: boolean;
  tooltipColumnIds?: string[];
  positionOn?: number;
}

function ODMTable({ columns, rows, navTable, onRowClick, selectedRowId, draggableRows, onDragStart, stickyColumnIds = [], heightTable, edit, tooltipColumnIds = [], positionOn}: Props) {
  const navigate = useNavigate();

  const [orderBy, setOrderBy] = React.useState<string>('');
  const [order, setOrder] = React.useState<'asc' | 'desc'>('asc');
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewSrc, setPreviewSrc] = React.useState<string | null>(null);
  const [maxRow, setMaxRow] = React.useState<number>(0);
  const [minRow, setMinRow] = React.useState<number>(0);
  const [rowsLength, setRowsLength] = React.useState<number>(0);
  const [defaultTableBodySize, setDefaultTableBodySize] = React.useState<number>(0);
  //const [lastScroll, setLastScroll] = React.useState<number>(0);
  const lastScrollRef = useRef(0);
  const stickyCellsRefs = useRef<Map<string, HTMLDivElement>[]>([]);
  const scrollRef = useRef<HTMLDivElement>(null);
  //const latestDataRef = useRef({ maxRow, minRow, rowsLength });

//  useEffect(() => {
//    setMinRow(0)
//    //setMaxRow(defaultTableBodySize)
//    setRowsLength(rows.length)
//    setMaxRow(rows.length < 100 ? rows.length : 100)
//  }, [rows]);

//  useEffect(() => {
//    latestDataRef.current = { minRow, maxRow, rowsLength };
//  }, [minRow, maxRow, rowsLength]);

//  useEffect(() => {
//    const node = scrollRef.current;
//    if (!node) return;
//
//    const onScroll = () => {
//      let lastScrollTop = 0;
//      let lastScrollLeft = 0;
//
//      return (event: Event) => {
//        const el = event.target as HTMLElement;
//        const { scrollTop, scrollLeft } = el;
//        if (el.scrollLeft !== lastScrollLeft) {
//          lastScrollLeft = el.scrollLeft;
//          return
//        }
//        if (node) {
//          const { maxRow, minRow, rowsLength } = latestDataRef.current;
//
//          const isNearBottom = (node.scrollHeight - node.scrollTop - node.clientHeight);
//          if (isNearBottom < 50 && maxRow <= rowsLength) {
//            setMaxRow(prev => prev + 10)
//            setMinRow(prev => prev + 10)
//          }
//          if (node.scrollTop < 50 && minRow > 0) {
//            node.scrollTop = node.scrollTop + 50
//            setMinRow(prev => prev - 10)
//            setMaxRow(prev => prev - 10)
//          }
//        }
//
//        setDefaultTableBodySize(node.clientHeight / 20)
//
//        lastScrollTop = el.scrollTop;
//      };
//    };
//
//    if (node) {
//      let frameId: any;
//
//      const update = () => {
//        const { maxRow, minRow, rowsLength } = latestDataRef.current;
//        //console.log(maxRow);
//        if (maxRow < 100 && maxRow < rowsLength) {
//          setMaxRow(prev => prev + 10)
//          setTimeout(() => {
//            frameId = requestAnimationFrame(update);
//          }, 800);
//        }
//      };
//      frameId = requestAnimationFrame(update);
//
//      const onScrollfunc = onScroll();
//      node.addEventListener('scroll', onScrollfunc);
//      return () => {
//        node.removeEventListener('scroll', onScrollfunc)
//        cancelAnimationFrame(frameId);
//      }
//    };
//  }, []);

  const handlePreviewOpen = (src: string) => {
    setPreviewSrc(src);
    setPreviewOpen(true);
  };

  const handlePreviewClose = () => {
    setPreviewOpen(false);
    setPreviewSrc(null);
  };

  const handleRowClick = (row: Row, index: number) => {
    if (onRowClick) {
      onRowClick(row, index);
    } else {
      const updatedNavTable = navTable.replace(/\{(id)\}/g, row.id);
      //console.log(updatedNavTable)
      navigate(updatedNavTable);
      // navigate(`/${navTable}/${row.id}`);
    }
  };

  const handleSort = (columnId: string) => {
    const isAsc = orderBy === columnId && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(columnId);
  };


  const positionSort = (aValue: string, bValue: string): number => {
    const lengthA = aValue.length;
    const lengthB = bValue.length;

    if (lengthA !== lengthB) {
      return (aValue.length == bValue.length) ? 0 :
        aValue == "" ? -1 :
          (aValue.length == 4 && bValue.length == 8) ? -1 :
            (aValue.length == 4 && bValue.length == 6) ? -1 :
              (aValue.length == 8 && bValue.length == 6) ? -1 : 1;
    }
    return aValue.localeCompare(bValue);
  };

    const updateStickyCells = (index: number, column_id: string, el: HTMLDivElement) => {
      if(!stickyCellsRefs.current.hasOwnProperty(index)){
        stickyCellsRefs.current[index] = new Map<string, HTMLDivElement>();
      }
      stickyCellsRefs.current[index].set(column_id, el);
    }

  const sortedRows = React.useMemo(() => {
    if (!orderBy) return rows;
    return [...rows].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (orderBy === 'position') {
        return order === 'asc' ? positionSort(aValue, bValue) : positionSort(bValue, aValue);
      }

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return order === 'asc' ? aValue - bValue : bValue - aValue;
      }

      return order === 'asc'
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }, [rows, orderBy, order]);

  useEffect(() => {
    if (positionOn && listRef.current) {
      var goto = positionOn * ROW_SIZE
      if(positionOn>14){
        goto = goto - 14 * ROW_SIZE
      }
      listRef.current.scrollTo(goto); 
    }
  }, [sortedRows]);

  const getStickyStyle = (
    columnIndex: number,
    isHeader: boolean,
    isSelected: boolean = false,
    isHovered: boolean = false,
  ): React.CSSProperties => {

  const stickyIds = columns
    .filter((c) => stickyColumnIds.includes(c.id))
    .map((c) => c.id);

    const currentId = columns[columnIndex].id;
    if (!stickyIds.includes(currentId)) return {};

    let left = 0;
    for (let i = 0; i < columnIndex; i++) {
      const col = columns[i];
      if (stickyIds.includes(col.id)) {
        left += col.minWidth || 99;
      }
    }

    let backgroundColor = isHeader
      ? '#e7e7e7'
      : isSelected
        ? '#f0f8ff'
        : isHovered
          ? '#f5f5f5'
          : '#ffffff';

    //console.log("name: " + columns[columnIndex].label)
    //console.log("left: " + left)
    return {
      position: 'sticky',
      left,
      zIndex: 99,
      backgroundColor,
    };
  };

  const ROW_SIZE = 32
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "block",
      flex: 1,
      height: "100%"
    },
    table: {
      height: "calc(100% - 40px)",
      width: "100%",
      tableLayout: "fixed",
    },
    list: {},
    thead: {
      height: "20px",
      width: "100%",
    },
    tbody: {
      width: "100%",
      overflow: "hidden",
    },
    row: {
      display: "flex !important",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignItems: "center",
      boxSizing: "border-box",
      minWidth: "100%",
      width: "100%",
      overflow: "hidden",
    },
    rowh: {
      display: "flex !important",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignItems: "center",
      boxSizing: "border-box",
      minWidth: "100%",
      width: "100%",
    },
    headerRow: {},
    cell: {
      display: "flex !important",
      alignItems: "center",
      height: ROW_SIZE,    
      //display: "block !important",
      flexGrow: 0,
      flexShrink: 0,

    },
    expandingCell: {
      flex: 1
    },
    column: {}
  }));
  const classes = useStyles();

  const RRow = ({ index, style, data: { columns, items, classes }  }: ListChildComponentProps<{
    columns: any[];
    items: any[];
    classes: any;
  }>) => {
    const row = items[index];
    const isSelected = selectedRowId == row.id;

    return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={index}
              onClick={() => handleRowClick(row, index)}
              draggable={draggableRows}
              onDragStart={draggableRows ? (e) => onDragStart?.(row, e) : undefined}
              sx={{
                cursor: 'pointer',
                backgroundColor: isSelected ? '#f0f8ff' : 'inherit',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                  '& .MuiTableCell-root': {
                    backgroundColor: '#f5f5f5',
                  },
                },
              }}
              component="div" 
              style={{
                ...style,
                top: (style.top as number) + ROW_SIZE,
              }}
              className={classes.row} 
            >
              {columns.map((column: any, columnIndex: any) => {
                const isSticky = stickyColumnIds.includes(column.id);
                const value = row[column.id];

                return (
                    <TableCell
                      key={index+"-"+column.id}
                      align={column.align || 'left'}
                      sx={{
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                        paddingTop: '0px !important',
                        paddingBottom: '0px !important',
                        maxWidth: tooltipColumnIds.includes(column.id) ? 150 : column.width,
                        //overflow: tooltipColumnIds.includes(column.id) ? 'hidden' : 'visible',
                        overflow: 'hidden',
                        textOverflow: tooltipColumnIds.includes(column.id) ? 'ellipsis' : 'unset',
                        //...(isSticky ? getStickyStyle(columnIndex, false, isSelected, false) : {}),
                        verticalAlign: "middle",
                        backgroundColor: isSelected ? '#f0f8ff' : '#ffffff',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                          '& .MuiTableCell-root': {
                            backgroundColor: '#f5f5f5',
                          },
                        },
                      }}
                      style={{
                        flexBasis: column.width || undefined,
                        //width: column.width,
                        height: ROW_SIZE,
                        //transform: isSticky ? `translateX(${lastScrollRef.current}px)` : undefined
                        zIndex: isSticky ? 2 : undefined,
                        // backgroundColor: '#ffffff'
                      }}
                      ref={(el: HTMLDivElement) => {
                        if (el && isSticky) updateStickyCells(index, column.id, el);
                      }}
                      component="div"
                      variant="body"
                      className={clsx(
                        classes.cell,
                        classes.column,
                        !column.width && classes.expandingCell
                      )}
                      scope="col"
                    >
                  <Tooltip
                    key={`${row.id}-${column.id}`}
                    title={
                      tooltipColumnIds.includes(column.id)
                        ? column.id === 'preview_image' && value != null
                          ? (<img src={previewSrc!} alt="Preview" style={{ width: '200px', height: 'auto' }} />)
                          : Array.isArray(value)
                            ? (
                              <ul style={{ paddingLeft: 16, margin: 0 }}>
                                {value.map((item: any, idx: number) => (
                                  <li key={idx} style={{ fontSize: '12px' }}>{item}</li>
                                ))}
                              </ul>
                            )
                            : value
                        : ''
                    }
                    arrow
                    placement="top"
                    disableHoverListener={!tooltipColumnIds.includes(column.id) || value==''}
                    onOpen={
                      column.id === 'preview_image' && value != null
                        ? () => handlePreviewOpen(value)
                        : () => {}
                        }
                    onClose={
                      column.id === 'preview_image' && value != null
                        ? () => handlePreviewClose()
                        : () => {}
                      }
                  >
                      {typeof value === 'string' && value.length > 30 &&
                        tooltipColumnIds.includes(column.id) && column.id != 'preview_image'
                        ? `${value.substring(0, 30)}...`
                        : column.format && typeof value === 'number'
                          ? column.format(value)
                          : column.id === 'video' && value != null
                            ? <img src={video} alt="video" width={20} />
                            : column.id === 'three_d' && value 
                              ? <img src={check} alt="" width={17} />
                              : column.id === 'json' && value 
                                ? <img src={check} alt="" width={17} />
                                : column.id === 'preview_image' && value != null
                                  ? <IconButton sx={{ p: 0 }}>
                                      <img src={preview} alt="preview" width={20} />
                                    </IconButton>
                                  : column.id === 'status' && (value === 'Non Pubblicabile' || value === 'Pubblicabile')
                                    ? <div style={{ margin: '0 auto', width: 10, height: 10, backgroundColor: 'red', borderRadius: '50%' }} />
                                    : column.id === 'status' && value === 'Pubblicato'
                                      ? <div style={{ margin: '0 auto', width: 10, height: 10, backgroundColor: 'green', borderRadius: '50%' }} />
                                      : (column.id === 'full_name' || column.id === 'name') && row['status'] === 'Non Pubblicabile'
                                        ? <>
                                          <img src={alert} alt="icon" width={20} /> {value}
                                        </>
                                        : ['gravity_management_complexity', 'motor_coordination_complexity', 'cardiorespiratory_complexity'].includes(column.id)
                                          ? <div className="time-badge">{value}</div>
                                          : ['start_date'].includes(column.id)
                                            ? <div style={{ margin: '10px' }}>{value}</div>
                                            : Array.isArray(value)
                                              ? value.join(', ')
                                              : value
                      }
                  </Tooltip>
                    </TableCell>
                );
              })}
            </TableRow>
        );
  }

  /**
   * itemKey function for returning the key prop for an item.
   * see https://react-window.vercel.app/#/api/FixedSizeList  -> itemKey prop
   */
  const itemKey = (index: number, data: any) => data.items[index].id;

  /**
   * wee define this here because I wanted to pass my  columns prop from App, and classes from ReactWindowTable
   * see https://react-window.vercel.app/#/api/FixedSizeList  -> itemData prop
   */
  const createItemData = memoize((classes: any, columns: any, data: any) => ({
    columns,
    classes,
    items: data
  }));
  
  const itemData = createItemData(classes, columns, sortedRows);

  const NoWrapper = React.forwardRef<HTMLDivElement>((props, ref) => (
    <React.Fragment {...props} />
  ));

  const OuterDiv = React.forwardRef<HTMLDivElement, any>((props, ref) => (
    <div ref={ref} {...props} style={{ ...props.style, overflowY: 'auto' }} />
  ));

  const InnerDiv = React.forwardRef<HTMLDivElement, any>((props, ref) => (
    <div ref={ref} {...props} style={{ ...props.style, width: '100%' }} />
  ));

  const NoHorizontalScroll = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    (props, ref) => (
      <div
        {...props}
        ref={ref}
        style={{
          ...props.style,
          overflowX: "hidden",
          overflowY: "auto",
          //width: "2000px"
        }}
      />
    )
  );

  const InnerWrapper = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ style, ...rest }, ref) => (
      <div
        ref={ref}
        style={{
          ...style,
          paddingTop: 150,
          width: "100%",
        }}
        {...rest}
      />
    )
  );

  const totalWidth = columns.reduce((acc, item) => acc + parseInt(item.width, 10), 0);

  const listRef = useRef<FixedSizeList>(null);

  function sumUntilSticky(columns: Column[], stickyColumnIds: string[]): number {
    let sum = 0;

    for (const col of columns) {
      if (stickyColumnIds.includes(col.id)) {
        break; // appena trovo la prima colonna sticky mi fermo
      }

      // estraggo il numero da width (es: "120px" -> 120)
      const widthValue = parseInt(col.width, 10);
      sum += isNaN(widthValue) ? 0 : widthValue;
    }

    return sum;
  }

  const totalNonStickyWidth = sumUntilSticky(columns, stickyColumnIds);

  const positionStickyCells = () => {
    stickyCellsRefs.current.forEach((map, index) => {
      if (map){
        for (const key of Array.from(map.keys())) {
          const el = map.get(key);
          if(el){
            if(lastScrollRef.current>0){
              el.style.transform = `translateX(${lastScrollRef.current-totalNonStickyWidth}px)`;
            } else {
              el.style.transform = `translateX(${lastScrollRef.current}px)`;
            }
          } else {
            stickyCellsRefs.current[index]?.clear();
            break;
          }
        }
      }
    });
  }

  const scrollTimeout = useRef<NodeJS.Timeout | null>(null);
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
      const target = e.currentTarget;
      const newLeft = target.scrollLeft;
      if (newLeft !== lastScrollRef.current) {
        if (scrollTimeout.current) clearTimeout(scrollTimeout.current);

        scrollTimeout.current = setTimeout(() => {
          //console.log("Scroll orizzontale:", newLeft);
          // listRef.current?.scrollToItem(0);
          //setLastScroll(newLeft);
          lastScrollRef.current = newLeft
          positionStickyCells();
        }, 50); 
      }
  };

  return (
    <div 
      className={classes.root}
    >
      <TableContainer
        sx={{ 
          height: heightTable ? heightTable : '100%',
        }}
        ref={scrollRef}
        onScroll={handleScroll}
      >
        <Table
          stickyHeader
          // aria-label="sticky table"
          sx={{
            '& .MuiTableCell-sizeSmall': { padding: '6px 0px' },
            '& .MuiTableCell-root': { padding: '4px 8px' },
          }}
          className={classes.table} 
          component="div"
        >
            <AutoSizer>
            {({ height, width }) => (
              <>
          <TableHead 
            component="div" 
            className={classes.thead}
          >
            <TableRow 
              component="div" 
              className={clsx(classes.rowh, classes.headerRow)} 
            >
              {columns.map((column, columnIndex) => {
                const isSticky = stickyColumnIds.includes(column.id);
                //console.log(column.id + " " + column.width)
                return (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    style={{
                      //minWidth: column.minWidth,
                      overflow: "hidden", 
                      backgroundColor: '#e7e7e7',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      whiteSpace: 'nowrap',
                      ...(isSticky ? { ...getStickyStyle(columnIndex, true) } : {}),
                      flexBasis: column.width || undefined,
                      //width: column.width,
                      height: ROW_SIZE
                    }}
                    sortDirection={orderBy === column.id ? order : false}
                    component="div"
                    variant="head"
                    className={clsx(
                      classes.cell,
                      classes.column,
                      !column.width && classes.expandingCell
                    )}
                    scope="col"
                  >
                    {['frequency', 'position', 'status', 'gravity_management_complexity', 'motor_coordination_complexity', 'cardiorespiratory_complexity', 'start_date', 'name'].includes(column.id) ? (
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : 'asc'}
                        onClick={() => handleSort(column.id)}
                      >
                        {column.label}
                      </TableSortLabel>
                    ) : (
                      column.label
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody component="div" className={classes.tbody}>
              <FixedSizeList
                ref={listRef}
                className={classes.list}
                height={height}
                itemCount={sortedRows.length}
                itemSize={ROW_SIZE}
                width={totalWidth}
                itemKey={itemKey}
                itemData={itemData}
                //outerElementType={NoHorizontalScroll}
                //innerElementType={InnerWrapper}
                //overscanCount={15}
                // style={{ height: 400, overflow: 'auto' }}
                onScroll={({ scrollDirection, scrollOffset, scrollUpdateWasRequested }) => {
                  positionStickyCells()
                }}
              >

                {RRow}
              </FixedSizeList>
        </TableBody>
        </>
            )}
          </AutoSizer>
        </Table>
      </TableContainer>
      </div>
  );
}
export default React.memo(
  ODMTable,
  (prevProps: any, nextProps: any) => {
    return prevProps.rows === nextProps.rows && prevProps.selectedRowId === nextProps.selectedRowId;
  }
);
